module.exports = __webpack_public_path__ + "static/media/pillars-left.71b0a633.webp";